<template>
  <div class="footerBox" :style="footerBackgroundImageStyle">
    <div class="footer_top">
      <div>
        <div class="head_img">
          <img src="@/assets/footer/footer-image.png" alt="" />
        </div>
        <div
          style="cursor: pointer"
          @click="handleclick()"
          class="footer_hema footer_none"
        >
          @2024河马艺术辽ICP备2024035926号
        </div>
      </div>
      <div class="footer_bottom">
        <div class="footer_tab">
          <div @click="linkJump(1, '/ArtistList')">艺术家列表</div>
          <div @click="linkJump(1, '/Artbuying')">艺术品租赁及购买</div>
          <div @click="linkJump(1, '/Example')">艺术品定制</div>
          <div @click="linkJump(1, '/AboutUs')">关于我们</div>
        </div>
        <div class="footer_hema hema">1 Pemimpin Dr, Singapore 576151</div>
        <div class="footer_phone">
          <div>
            <div class="footer_phone_title">新加坡地区</div>
            <div class="flex_gap">
              <div class="footer_phone_content mr">
                MICKY LI
                <br />
                移动电话:+65 81002141
                <br />
                办公电话:+65 65136136
              </div>

              <div class="footer_phone_content">
                SARAH ZHANG
                <br />
                移动电话:+65 88828125
                <br />
                办公电话:+65 65136136
              </div>
            </div>
          </div>
          <div>
            <div class="footer_phone_title">中国大陆地区</div>
            <div class="flex_gap">
              <div class="footer_phone_content mr">
                杨晨
                <br />
                移动电话: +86 13842865613
              </div>
              <div class="footer_phone_content">
                <div>
                  闫铮
                  <br />
                  移动电话: +86 13466624570
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
// import VueQr from "vue-qr";
export default {
  components: {},
  data() {
    return {
      navStatus: null,
    };
  },
  computed: {
    footerBackgroundImageStyle() {
      if (this.windowWidth >= 1024) {
        return {
          backgroundImage: `url(${require("@/assets/footer/footer-Rectangle.png")})`,
        };
      } else {
        return {
          background:
            "radial-gradient(100% 300% at 0% 30%, #ece6ff 0%, #f2fcff 33%, #d5e6ff 100%",
        };
      }
    },
  },

  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    handleclick() {
      window.open("https://beian.miit.gov.cn/");
    },
  },
  watch: {},
  created() {},
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="less" scoped>
@import "~@/static/styles/variables.less";
.footerBox {
  width: 100vw;
  background-size: 100% 100%;
  // text-align: center;
  .footer_top {
    width: @commentWidth;
    margin: 0 auto;
    padding-top: 0.2604rem;
    padding: 0.2604rem 0.1563rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    .head_img {
      width: 1.0156rem;
      height: 0.2708rem;
      margin-right: 8px;
      border-radius: 50%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    span {
      font-size: 16px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      line-height: 19px;
    }
    .footer_hema {
      font-family: Source-Regular;
      font-weight: 400;
      font-size: 0.0938rem;
      color: #999999;
      line-height: 0.1094rem;
      margin-top: 0.2604rem;
      margin-bottom: 0.1042rem;
    }
    .hema {
      text-align: right;
      margin-top: 0.3229rem;
    }
    .footer_bottom {
      display: flex;
      flex-direction: column;
    }
    .footer_tab {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
      div {
        font-family: Source-Regular;
        font-weight: 400;
        font-size: 0.0938rem;
        color: #333333;
        line-height: 0.1094rem;
        cursor: pointer;
      }
    }
  }
  .footer_phone {
    display: flex;
    gap: 0.1042rem;
    .flex_gap {
      display: flex;
      gap: 0.1042rem;
    }
    .footer_phone_title {
      font-size: 0.0833rem;
      color: #999999;
      margin-bottom: 0.0573rem;
      line-height: 0.125rem;
      font-family: Source-Regular;
    }
    .footer_phone_content {
      font-size: 0.0729rem;
      color: #999999;
      line-height: 0.125rem;
      font-family: Source-Regular;
    }
    .mr {
      margin-right: 0 !important;
    }
  }
}
@media screen and (max-width: 1024px) {
  .footerBox {
    // height: 100%;
    .footer_top {
      width: 100%;
      // padding-top: 0.5333rem;
      padding-bottom: 0.5rem;
      flex-direction: column;
    }
  }
  .footerBox .footer_top {
    margin-bottom: 0;
    .footer_tab {
      flex-direction: column;
      gap: 0.4rem;
      div {
        font-size: 0.32rem;
        line-height: 0.3733rem;
        color: #666666;
      }
    }
    .hema {
      text-align: center;
    }
  }
  .footer_none {
    display: none;
  }
  .footerBox .footer_top .head_img {
    width: 3.28rem;
    height: 0.88rem;
    margin-bottom: 0.6rem;
  }
  .footerBox .footer_top .footer_hema {
    font-family: Source-Regular;
    font-weight: 400;
    font-size: 0.24rem;
    color: #999999;
    line-height: 0.2933rem;
    margin-top: 0.4rem;
    margin-bottom: 0.4rem;
  }
  .footer_phone {
    display: flex;
    flex-direction: column;
    .flex_gap {
      display: flex;
      gap: 0.5333rem !important;
      justify-content: center;
    }
    .footer_phone_title {
      font-size: 0.32rem !important;
      color: #999999;
      margin-bottom: 0.0573rem;
      line-height: 0.48rem !important;
      font-family: Source-Regular;
      text-align: center;
    }
    .footer_phone_content {
      font-size: 0.24rem !important;
      color: #999999;
      line-height: 0.4rem !important;
      font-family: Source-Regular;
    }
    .mr {
      margin-right: 0.1042rem;
    }
  }
}
</style>
<style lang="less">
.el-carousel--horizontal {
  height: 100%;
}
.el-carousel__container {
  height: 100%;
}
.el-carousel__indicators--horizontal {
  left: 89%;
}
.el-carousel__button {
  width: 20px;
}
</style>
